import React, { useRef, useState, useEffect } from 'react';
import { Box } from '@components/Box';
import {
  BlogCenterTextPairing,
  SliderContainer,
  SlideBackgroundImage,
  StyledMobileSection,
  StyledBox,
  RegistryDreamWrapper,
} from './RegistryDreamStartHereSection.styles';
import { registryPageData } from '@data-ts/pages/honeymoon-registry';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { defaultBase64Placeholder } from '@components/CloudImage';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';

const publicCatalogSection = registryPageData.registryDreamStartHereSection;

interface RegistryDreamStartHereSectionProps {}

export const RegistryDreamStartHereSection: React.FC<RegistryDreamStartHereSectionProps> = () => {
  const CashFreeGiftingRef = useRef<HTMLDivElement>(null);
  let [isScrolledIntoView, setScrolledIntoView] = useState(false);
  const slideImgs = publicCatalogSection.slides;

  useEffect(() => {
    const timeInterval = 5;
    var slideNumber = 1;
    var prevSlide = 0;
    const interval = setInterval(() => {
      if (slideNumber == slideImgs.length) {
        slideNumber = 0;
      }
      document.getElementById(`slide${prevSlide}`)!.classList.remove('slideActive');
      document.getElementById(`slide${slideNumber}`)!.classList.add('slideActive');
      if (slideNumber < slideImgs.length) {
        prevSlide = slideNumber;
        slideNumber++;
      }
    }, timeInterval * 1000);
    return () => clearInterval(interval);
  }, [slideImgs.length]);

  return (
    <StyledMobileSection as="section" id="Honeymoon_Dream_Start" marginTop={[10, 12]} ref={CashFreeGiftingRef}>
      <SliderContainer id="SliderContainer">
        {slideImgs.map((slide, k) => {
          return (
            <SlideBackgroundImage
              key={`slide${k}`}
              id={`slide${k}`}
              className={k === 0 ? 'slideActive slideImg' : 'slideImg'}
              backgroundColor={slide.bgColor}
              backgroundImage={isScrolledIntoView ? slide.bgImage : defaultBase64Placeholder}
              backgroundImageMobile={isScrolledIntoView ? slide.bgImageMobile : defaultBase64Placeholder}
            >
              <LazyLoadWrapper beforeLoad={() => setScrolledIntoView(true)}>
                <div />
              </LazyLoadWrapper>
              <RegistryDreamWrapper flexDirection="column" alignItems="center">
                <StyledBox alignItems="center">
                  <BlogCenterTextPairing
                    alignment="center"
                    eyebrow={publicCatalogSection.eyebrow}
                    eyebrowColor={slide.eyebrowColor}
                    eyebrowVariant="sectionEyeBrow24"
                    eyebrowTagName="h2"
                    title={publicCatalogSection.title}
                    titleVariant="hed56"
                    titleColor={slide.titleColor}
                    titleTagName="h2"
                    body={publicCatalogSection.body}
                    bodyVariant="dek24"
                    bodyColor={slide.bodyColor}
                    bodyTagName="p"
                  />
                </StyledBox>
                <Box style={{ textAlign: 'center', position: 'relative', zIndex: 2 }} marginTop={[8, 8]}>
                  <GetStartedButton id={`honeymoonDreamStartGetStartedBtn${k}`} page={'registry'} variant="primary">
                    {registryPageData.getStarted}
                  </GetStartedButton>
                </Box>
              </RegistryDreamWrapper>
            </SlideBackgroundImage>
          );
        })}
      </SliderContainer>
    </StyledMobileSection>
  );
};
